export const FieldTypeComponent = Symbol('FieldTypeComponent');
export const ContainerTypeComponent = Symbol('ContainerTypeComponent');
